import { RouteConfig } from 'vue-router'
const Index = () => import('../views/dynamic-page/index.vue')

export const indexRoute: RouteConfig = {
  path: '/dynamic-config-home',
  name: 'dynamic_config_home',
  component: Index,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '体智云',
    ignoreLogin: true,
  },
}

export default [indexRoute]
